import { defineModel } from "../define-model";

export type PostArtifact = {
	id: string;
	workspaceId: string;
	projectId: string | null;
	postId: string;
	artifactId: string;
	position: number;
	createdAt: string;
};

declare module "../types" {
	interface SyncModels {
		postArtifact: PostArtifact;
	}
}

export const model = defineModel({
	name: "postArtifact",
	load: "lazy",
	indexes: ["postId", "projectId"],
	sort: (a, b) => a.position - b.position,
});
